import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueCookies from "vue-cookies";
import VueGtag from "vue-gtag-next";
import { LOGOUT_SIGNAL_KEY } from "./store/modules/userStore";
const app = createApp(App);

app.use(store);
app.use(router);
app.use(VueCookies);
app.config.globalProperties.$cookies.config("1d");

// ① 탭이 열릴 때, 세션이 이미 만료됐으면 로그인된 것처럼 보이지 않게 정리
store.dispatch("userStore/INVALIDATE_IF_EXPIRED");

// ③ 다른 탭에서 로그아웃/만료되면 이 탭도 즉시 로그아웃
window.addEventListener("storage", (e) => {
  if (e.key !== LOGOUT_SIGNAL_KEY || !e.newValue) return;
  if (!store.getters["userStore/isLogin"]) return;
  store.dispatch("userStore/SYNC_LOGOUT");
  // 보호 페이지에 있었다면 로그인 화면으로 이동
  if (router.currentRoute.value.matched.some((r) => r.meta.authRequired)) {
    router.replace({ name: "Login" }).catch(() => {});
  }
});

app.mount("#app");

if (process.env.VUE_APP_GTAG_ID) {
  app.use(VueGtag, {
    property: {
      id: process.env.VUE_APP_GTAG_ID,
    },
  });
}

if (process.env.NODE_ENV === "production") {
  const script = document.createElement("script");
  script.src = "https://web.nicepay.co.kr/v3/webstd/js/nicepay-3.0.js";
  script.async = true;
  script.onerror = () => {
    console.warn("NicePay script load failed");
  };
  document.head.appendChild(script);
}
